import { createSlice } from "@reduxjs/toolkit";

const basicInfo = createSlice({
  name: "basicInfo",
  initialState: {
    isAuthenticated: false,
    userDetails: {},
    latestChatRooms: {
      unread_message_count: 0,
      latest_chat_rooms: [],
    },
  },
  reducers: {
    fetchBasicInfo: (state, action) => {
      state.isAuthenticated = action.payload.isAuthenticated;
      state.userDetails = action.payload.userInfo;
      state.latestChatRooms = action.payload.latestChatRooms;
    },
    logout: (state, action) => {
      state.isAuthenticated = false;
      state.userDetails = {};
    },
    updateLatestChatRoomsList: (state, action) => {
      state.latestChatRooms.unread_message_count =
        action.payload.unread_message_count;

      let data = state.latestChatRooms.latest_chat_rooms;

      // If the chat room is already in the list, update the message
      if (
        state.latestChatRooms?.latest_chat_rooms?.findIndex(
          (item) => item.channel_id === action.payload.chat_room_info.channel_id
        ) !== -1
      ) {
        data = state.latestChatRooms.latest_chat_rooms.map((item) => {
          if (item.channel_id === action.payload.chat_room_info.channel_id) {
            return action.payload.chat_room_info;
          }
          return item;
        });
      } else {
        // If the chat room is not in the list, add it
        data = [
          action.payload.chat_room_info,
          ...state.latestChatRooms.latest_chat_rooms,
        ];
      }

      // Sort the list by latest message date
      data.sort((a, b) => {
        return new Date(b.last_activity) - new Date(a.last_activity);
      });

      // At a time only show the latest 5 chat rooms
      data = data.slice(0, 5);

      state.latestChatRooms.latest_chat_rooms = data;
    },
    updateTotalRoomUnreadMessageCount: (state, action) => {
      state.latestChatRooms.unread_message_count = action.payload;
    },
  },
});

export const {
  fetchBasicInfo,
  logout,
  updateLatestChatRoomsList,
  updateTotalRoomUnreadMessageCount,
} = basicInfo.actions;
export default basicInfo.reducer;
